import instance from "./axios";

export const venders = async () => {
  const { data } = await instance.get(`vendorData/vendor`);

  return data;
};
export const toggleButtonVendeors = async (path, id) => {
  const { data } = await instance.post(`users/odoUsers?path=${path}`, { id });
  return data;
};
export const goUsers = async (path) => {
  const { data } = await instance.get(`users/goUsers`);
  return data; 
};
export const getAllOrder = async () => {
  const { data } = await instance.get("users/allOrder");
  return data;
};

export const toggleButtongoUsers = async (userid, path) => {
  const { data } = await instance.put(`users/goUsers?path=${path}`, { userid });
  return data;
};

export const incartUsers = async (path) => {
  const { data } = await instance.get(`users/cartItem?path=${path}`);
  return data;
};
export const allUser = async () => {
  const { data } = await instance.get("users/allUser");
  return data;
};
export const allInCartdata = async () => {
  const { data } = await instance.get("users/allInCartdata");
  return data;
};

export const changeLeadStatusApi = async (status, id,path) => {
  const { data } = await instance.post(`weblead/leadStatus?path=${path}`,{status, id});
  return data;
};

export const UsersCart = async (userid, path) => {
  const { data } = await instance.post(`users/cartItem?path=${path}`, { userid });
  return data;
};
export const changeLeadDetails = async (path, update) => {
  const { data } = await instance.post(`weblead/leads?path=${path}`,{update});
  return data;
};
export const allProposalsApi = async (path, id) => {
 
  const { data } = await instance.put(`weblead/leads?path=${path}`, {id});
  return data;
};

export const createProposalApi = async (path,id, upperData,companydata, arrays) => {
  const { data } = await instance.post(`weblead/proposal?path=${path}`, {id, upperData,companydata, arrays});
  return data;
};

export const propsalAddressApi = async (email, related) => {
  const { data } = await instance.put(`weblead/proposal`, {email,related});
  return data;
};

export const assignedList = async () => {
  const { data } = await instance.get(`weblead/assignLead`);
  return data;
};
export const allLeadsList = async (path) => {
  const { data } = await instance.get(`weblead/leads?path=${path}`);
  return data;
};
export const ODOLeads = async (path) => {
  const { data } = await instance.get(`weblead/syncleads?path=${path}`);
  return data;
};

export const otherlead = async (path) => {
  const { data } = await instance.put(`weblead/syncleads?path=${path}`);
  return data;
};

export const emailsLists = async(related) =>{
  const { data } = await instance.get(`weblead/proposal?related=${related}`);
  return data;
}
export const allActivityies = async(id) =>{
  const { data } = await instance.get(`weblead/activity/${id}`);
  return data;
}

export const allReminder = async(id) =>{
  const { data } = await instance.get(`weblead/reminder/${id}`);
  return data;
}
export const activityNotes = async(path,id, note) =>{
  const { data } = await instance.post(`weblead/assignLead?path=${path}`,{id, note});
  return data;
}
export const createReminder = async(path,reminderForm) =>{
  const { data } = await instance.put(`weblead/assignLead?path=${path}`,{reminderForm});
  return data;
}
export const createNewLead = async(path,  update) =>{
  const { data } = await instance.post(`weblead/createLead?path=${path}`,{update});
  return data;
}

export const createVendorApi = async(path, posts) =>{
  const { data } = await instance.post(`users/allOrder?path=${path}`,{posts});
  return data;
}

export const createVendorData = async (vandor, posts, userid, password,campaign_id) => {
  const { data } = await instance.post(`vendorData/vendor`,{vandor, posts, userid, password,campaign_id});
  return data;
};

export const getVendorData = async () => {
  const { data } = await instance.get(`vendorData/vendorData`);
  return data;
};

export const insertSiteData = async (posts, vendorname,campaign_Id) => {
  const { data } = await instance.post(`vendorData/vendorData`,{posts, vendorname,campaign_Id});
  return data;
};

export const vandorDetails = async (vendor) => {
  const { data } = await instance.get(`vendorData/details/${vendor}`);
  return data;
};
export const leadSources = async () => {
  const { data } = await instance.get(`weblead/createLead`);
  return data;
};

export const updateCampaignApi= async (selectCampaign) => {
  const { data } = await instance.patch(`campaign/campaignUpdate`,{selectCampaign});
  return data;
};

export const makeXlSX= async (jsonData) => {
  const { data } = await instance.post(`campaign/csv`,{jsonData});
  return data;
};

export const odoleadstatusChange= async (status,id,path) => {
  const { data } = await instance.put(`campaign/campaignUpdate?path=${path}`,{status,id});
  return data;
};

export const gohBlogUpload= async (formData) => {
  const { data } = await instance.post(`blogs/gohblogs?path=/blog`,formData);
  return data;
};

export const fetchBlogs= async () => {
  const { data } = await instance.get(`blogs/gohblogs?path=/blog`);
  return data;
};

export const fetcheditBlog= async (id) => {
  const { data } = await instance.patch(`blogs/gohblogs`,{id});
  return data;
};

export const gohBlogUpdate= async (formData) => {
  const { data } = await instance.put(`blogs/gohblogs?path=/blog`,formData);
  return data;
};

export const gohBlogUpdateStatus= async (id,status) => {
  const { data } = await instance.put(`blogs/blogs?path=/blog`,{id,status});
  return data;
};

export const newsUpload= async (formData) => {
  const { data } = await instance.post(`news/newsmedia?path=/blog`,formData);
  return data;
};

export const fetchNews= async () => {
  console.log("vvv")
  const { data } = await instance.get(`news/newsmedia?path=/blog`);
  return data;
};

export const newsUpdateStatus= async (id,status) => {
  const { data } = await instance.put(`news/newsmediastatus?path=/blog`,{id,status});
  return data;
};

export const fetcheditNews= async (id) => {
  const { data } = await instance.patch(`news/newsmedia`,{id});
  return data;
};

export const newsUpdate= async (formData) => {
  const { data } = await instance.put(`news/newsmedia?path=/blog`,formData);
  return data;
};

export const years = [
  {
    id: 1,
    value: "2019",
    lable: "2019",
  },
  {
    id: 2,
    value: "2020",
    lable: "2020",
  },
  {
    id: 3,
    value: "2021",
    lable: "2021",
  },
  {
    id: 4,
    value: "2022",
    lable: "2022",
  },
  {
    id: 5,
    value: "2023",
    lable: "2023",
  },
];

export const months = [
    {id:1, lable: "January", value: "01" },
    { id:2, lable: "February", value: "02" },
    { id:3, lable: "March", value: "03" },
    { id:4, lable: "April", value: "04"},
    { id:5, lable: "May", value: "05" },
    { id:6, lable: "June", value: "06" },
    { id:7, lable: "July", value: "07"},
    { id:8, lable: "August", value: "08" },
    { id:9, lable: "September", value: "09" },
    { id:10, lable: "October", value: "10" },
    { id:11, lable: "November", value: "11" },
    { id:12, lable: "December", value: "12"}
];

